import { render, staticRenderFns } from "./AcademyMode.vue?vue&type=template&id=7a917eb7&scoped=true&lang=pug&"
import script from "./AcademyMode.vue?vue&type=script&lang=ts&"
export * from "./AcademyMode.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyMode.vue?vue&type=style&index=0&id=7a917eb7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a917eb7",
  null
  
)

export default component.exports